import React from 'react';
import { useFormik } from 'formik';
import styled from 'styled-components';
import * as Yup from 'yup';
import { AuthCodeInput, Button, ButtonRetry, ModalContent, ModalHeader, ModalText, ModalTitle } from 'components';
import { theme, toRem } from 'design';
import Validations from 'lib/Validations';
import Form from 'screens/Error/Form';
import { NeedHelpLink } from './styles';

interface IVerificationFormProps {
  email: string;
  isLoading: boolean;
  isResendLoading: boolean;
  errorMessages: string[];
  onSubmit: (verificationCode: string) => void;
  resendVerificationCode: () => void;
}

const StyledButtonRetry = styled(ButtonRetry)`
  margin-top: ${toRem(theme.space['2xl'])};
`;

const StyledButton = styled(Button)`
  margin-top: ${toRem(theme.space['2xl'])};
`;

const EmailVerificationForm: React.FC<IVerificationFormProps> = ({ email, isLoading, isResendLoading, errorMessages, onSubmit, resendVerificationCode }) => {
  const validationSchema = Yup.object().shape({
    code: Validations.verificationCodeValidationSchema,
  });

  const { handleSubmit, dirty, isValid, setFieldValue } = useFormik({
    initialValues: {
      code: '',
    },
    onSubmit: (values: { code: string }) => {
      onSubmit(values.code);
    },
    validateOnChange: true,
    validationSchema,
  });

  return (
    <>
      <ModalHeader>
        <ModalTitle>Confirm Email</ModalTitle>
        <ModalText marginTop={theme.space.md}>
          Enter the code sent to your email:
          <br />
          <strong>{email}</strong>
        </ModalText>
      </ModalHeader>

      <ModalContent>
        <Form onSubmit={handleSubmit}>
          <AuthCodeInput errorMessages={errorMessages} onChange={(val) => setFieldValue('code', val)} />
          <StyledButton data-cy="submit-confirm-identity" type="submit" label="Continue" disabled={isLoading || !(isValid && dirty)} isProcessing={isLoading} />
        </Form>

        <StyledButtonRetry dataCy="resend-verification-code" label="Resend verification code" onClick={resendVerificationCode} isLoading={isResendLoading} />

        <NeedHelpLink>Need some help?</NeedHelpLink>
      </ModalContent>
    </>
  );
};

export default EmailVerificationForm;
